import { render } from "./LanguagesView.vue?vue&type=template&id=22185534&scoped=true"
import script from "./LanguagesView.vue?vue&type=script&scoped=true&lang=js"
export * from "./LanguagesView.vue?vue&type=script&scoped=true&lang=js"

import "./LanguagesView.vue?vue&type=style&index=0&id=22185534&scoped=true&lang=css"

import exportComponent from "C:\\Source\\LETC\\LETC_VueRouterWeb\\letc_vr_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22185534"]])

export default __exports__